import React from "react";
import { Accordion } from "grommet";
import { StyledPanel, StyledWrapper } from "./styles";
export var AccordionPanel = function AccordionPanel(_ref) {
  var _ref$initialState = _ref.initialState,
    initialState = _ref$initialState === void 0 ? [] : _ref$initialState,
    format = _ref.format,
    children = _ref.children;

  var _React$useState = React.useState(initialState),
    activeIndex = _React$useState[0],
    setActiveIndex = _React$useState[1];

  var title = format.title;
  return /*#__PURE__*/ React.createElement(
    Accordion,
    {
      activeIndex: activeIndex,
      onActive: function onActive(index) {
        return setActiveIndex(index);
      },
    },
    /*#__PURE__*/ React.createElement(
      StyledPanel,
      {
        label: title || "Формат",
      },
      /*#__PURE__*/ React.createElement(StyledWrapper, null, children)
    )
  );
};
